<template>
  <div class="main" v-loadMore="getList">
    <img class="bg-img" :src="backgroundImage" alt="" />
    <div class="input-box">
      <input
        type="text"
        placeholder="搜尋 ID"
        v-model="params.userUuid"
        @keyup.enter="searchList()"
      />
      <img
        class="icon"
        src="./images/search.png"
        alt=""
        srcset=""
        @click="searchList()"
      />
    </div>
    <div class="list-box">
      <div
        class="item"
        v-for="item of list"
        :key="item.userUuid"
        @click="toPlayerDetail(item.userUuid)"
      >
        <img class="img-main" :src="item.imageUrl" alt="" />
        <div class="detail-box">
          <p class="content">{{ item.content }}</p>
          <div class="info-box">
            <div class="left">
              <img class="avatar" :src="item.avatarUrl" alt="" />
              <span class="name">{{ item.nikeName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="action-box">
      <button class="btn-countdown" @click="publish()">
        {{ status === 1 ? '重新投稿' : '我要投稿' }}
      </button>
    </div>
    <publish-dialog
      ref="publishDialog"
      :uuid="uuid"
      :votesType="votesType"
      @success="refresh()"
    ></publish-dialog>
  </div>
</template>
<script>
import publishDialog from './publish-dialog.vue';
export default {
  components: { publishDialog },
  name: 'SubmissionStage',
  data() {
    return {
      params: {
        cp_SUFFIX_NUM: 0,
        pageIndex: null,
        pageSize: 20,
        params: {},
        userUuid: ''
      },
      listLoading: false,
      list: [],
      pageTotal: 0,
      votingLoading: false
    };
  },
  props: {
    status: {
      type: Number
    },
    uuid: {
      type: String
    },
    votesType: {
      type: String
    },
    endDate: {
      type: [Number, String]
    },
    backgroundImage: {
      type: String
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
    publish() {
      if (new Date().getTime() >= this.endDate) {
        this.$confirm({
          content: '投稿已截止',
          confirmButtonText: '確定',
          className: 'custom-draw-dialog',
          showCancelButton: false,
          closeOnClickModal: false
        }).then(() => {
          this.refresh();
        });
        return;
      }
      this.$refs.publishDialog.show();
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    searchList() {
      this.params.pageIndex = null;
      this.pageTotal = 0;
      this.list = [];
      this.getList();
    },
    async getList() {
      if (this.listLoading) {
        return;
      }
      try {
        if (
          (this.params.pageIndex === null ||
            this.list.length < this.pageTotal) &&
          !this.listLoading
        ) {
          if (this.params.pageIndex === null) {
            this.params.pageIndex = 0;
          } else {
            this.params.pageIndex += 1;
          }
          this.listLoading = true;
          this.params.votesType = this.votesType;
          const { data } = await this.$http.post('/votes/page', this.params);
          if (!data) {
            this.list = this.list || [];
            return;
          }
          this.list = data.content? this.list.concat(data.content) : [];
          this.pageTotal = data.totalRemain;
        }
      } catch (error) {
        if (this.params.pageIndex === 0) {
          this.params.pageIndex = null;
        } else {
          this.params.pageIndex -= 1;
        }
      } finally {
        this.listLoading = false;
      }
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 750px;
  flex: none;
  > .bg-img {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    flex: none;
  }
  .input-box {
    height: 72px;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
    input {
      width: 686px;
      height: 72px;
      background: rgba(255, 255, 255, 0.14);
      border-radius: 999px;
      flex: none;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 26px;
      padding: 0 28px;
      color: white;
      &::placeholder {
        font-weight: 400;
        font-size: 26px;
        color: rgba(255, 255, 255, 0.55);
      }
    }
    .icon {
      position: absolute;
      right: 48px;
      top: 50%;
      transform: translateY(-50%);
      width: 52px;
      height: 52px;
    }
  }
  .list-box {
    width: 100%;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 206px;

    .item {
      width: 334px;
      height: 514px;
      background: rgba(255, 255, 255, 0.14);
      border-radius: 32px;
      display: flex;
      flex-direction: column;
      margin-bottom: 18px;
      .img-main {
        width: 100%;
        height: 334px;
        border-radius: 16px;
        background: white;
        object-fit: cover;
      }
      .detail-box {
        padding: 0 25px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        flex: auto;
      }
      .content {
        height: 36px;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 26px;
        color: #ffffff;
        width: 100%;
        overflow: hidden;
      }
      .info-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 22px;
        width: 100%;
        overflow: hidden;
        .left {
          display: flex;
          align-items: center;
          .avatar {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            margin-right: 4px;
          }
          .name {
            font-weight: 400;
            font-size: 22px;
            color: rgba(255, 255, 255, 0.77);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 160px;
          }
        }
        .right {
          font-weight: 400;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.77);
          min-width: 80px;
          text-align: right;
        }
      }
      .btn-confirm {
        width: 100%;
        height: 66px;
        background: #ffcb46;
        border-radius: 80px;
        font-size: 26px;
        color: #2e2e2e;
        margin-bottom: 18px;
        &.disabled {
          background: rgba(255, 203, 70, 0.55);
        }
      }
    }
  }
  .action-box {
    flex: none;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 256px;
    background: linear-gradient(180deg, rgba(3, 0, 46, 0) 0%, #03002e 22.62%);
    display: flex;
    align-items: center;
    justify-content: center;
    .btn-countdown {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 614px;
      height: 88px;
      background: #ffcb46;
      border-radius: 40px;
      font-weight: 600;
      font-size: 32px;
      line-height: 44px;
      color: #2e2e2e;
    }
  }
}
</style>
